StepActionsView = require "../step_actions_view"
CommonBaseInputsView = require "../common/views/common_base_inputs_view"
SupportUtils = require "../../helpers/utils"
SharedAjaxError = require "../../../../shared/frontend/views/ajax_error_view"
SupportStepThreeActionsTemplate = require '../../../step_three_actions.html.mustache'

class EmailFormBaseView extends CommonBaseInputsView
  className: 'email-form'

  initialize: ->
    CommonBaseInputsView::initialize.apply(this, arguments)
    @I18nScope = 'modules.support'

  renderStepActions: ->
    stepActionsView = new StepActionsView
      template: SupportStepThreeActionsTemplate
    stepActionsView.render()
    @$el.append(stepActionsView.el)

  hideComponents: ->
    SupportUtils.hideFloatingBoldChat()

  renderSuccess: (response)->
    window.location.href = "#ticket-success"

  renderError: ->
    errorView = new SharedAjaxError()
    errorView.render({container: $('#help-wizard')})

  submitForm: (data)->
    createTicket(data, @renderSuccess, @renderError, $('.help-wizard'))

module.exports = EmailFormBaseView
